/**
 * Password policy constants
 *
 * The live password regex comes from Ascend (TtgApplicationSettings.PasswordRegex) via AOEConfig.PasswordRegex.
 * DEFAULT_PASSWORD_REGEX mirrors the Ascend Core.Common default and is only used when the configured regex
 * is unavailable, so client-side validation fails closed instead of accepting any password.
 */

export const DEFAULT_PASSWORD_REGEX = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$'
